import React, { useState, useEffect } from 'react';
    import { motion } from 'framer-motion';
    import { useNavigate } from 'react-router-dom';
    import { useAuth } from '../context/AuthContext';
    import AdminHeader from '../components/admin/AdminHeader';
    import ProfilesTab from '../components/admin/ProfilesTab';
    import PendingTab from '../components/admin/PendingTab';
    import TagsTab from '../components/admin/TagsTab';
    import PendingJobsTab from '../components/admin/PendingJobsTab';
    import PendingEventsTab from '../components/admin/PendingEventsTab';
    import PendingDealsTab from '../components/admin/PendingDealsTab';
    import SettingsTab from '../components/admin/SettingsTab';

    const AdminDashboard = () => {
        const [activeTab, setActiveTab] = useState('approved');
        const { user, loading } = useAuth();
        const navigate = useNavigate();

        useEffect(() => {
            if (!loading && !user) {
                navigate('/admin');
            }
        }, [user, loading, navigate]);

        if (loading) {
            return (
                <div className="min-h-screen flex items-center justify-center">
                    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-yellow-500"></div>
                </div>
            );
        }

        if (!user) {
            return null;
        }

        const tabs = [
            { id: 'approved', label: 'Approved Profiles' },
            { id: 'pending', label: 'Pending Profiles' },
            { id: 'tags', label: 'Tag Manager' },
            { id: 'pending_jobs', label: 'Pending Jobs' },
            { id: 'pending_events', label: 'Pending Events' },
            { id: 'pending_deals', label: 'Pending Deals' },
            { id: 'settings', label: 'Settings' },
        ];

        return (
            <div className="min-h-screen bg-gray-50">
                <AdminHeader />
                <div className="container mx-auto px-4 py-8">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <h1 className="text-4xl font-bold text-gray-900 mb-8">Admin Dashboard</h1>
                        {/* Tabs */}
                        <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-8">
                            <div className="border-b border-gray-200">
                                <nav className="flex overflow-x-auto">
                                    {tabs.map((tab) => (
                                        <button
                                            key={tab.id}
                                            onClick={() => setActiveTab(tab.id)}
                                            className={`px-6 py-4 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                                                activeTab === tab.id
                                                    ? 'border-yellow-500 text-yellow-500'
                                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                            }`}
                                        >
                                            {tab.label}
                                        </button>
                                    ))}
                                </nav>
                            </div>
                            <div className="p-6">
                                {activeTab === 'approved' && <ProfilesTab />}
                                {activeTab === 'pending' && <PendingTab />}
                                {activeTab === 'tags' && <TagsTab />}
                                {activeTab === 'pending_jobs' && <PendingJobsTab />}
                                {activeTab === 'pending_events' && <PendingEventsTab />}
                                {activeTab === 'pending_deals' && <PendingDealsTab />}
                                {activeTab === 'settings' && <SettingsTab />}
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        );
    };

    export default AdminDashboard;